import * as React from "react";
import type { SVGProps } from "react";
const SvgIconWorst = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_6809_5994)">
      <path
        d="M11.43 2.05c.31-.33.83-.33 1.14 0l1.3 1.35c.21.21.52.3.8.21l1.81-.52c.43-.12.88.14 1 .58l.45 1.82c.07.29.3.51.58.58l1.82.46c.44.1.7.56.58.99l-.52 1.8c-.09.3 0 .6.2.8l1.36 1.3c.33.32.33.84 0 1.15l-1.35 1.3c-.21.21-.3.52-.21.8l.52 1.81c.12.43-.14.88-.58 1l-1.82.45c-.29.07-.51.3-.58.58l-.46 1.82c-.1.44-.56.7-.99.58l-1.8-.52c-.3-.09-.6 0-.8.2l-1.3 1.36c-.32.33-.84.33-1.15 0l-1.3-1.35c-.21-.21-.52-.3-.8-.21l-1.81.52c-.43.12-.88-.14-1-.58l-.45-1.82c-.07-.29-.29-.51-.58-.58l-1.82-.46c-.44-.1-.7-.56-.58-.99l.52-1.8c.09-.3 0-.6-.2-.8l-1.36-1.3c-.33-.32-.33-.84 0-1.15l1.35-1.3c.21-.21.3-.52.21-.8L3.1 7.52c-.12-.43.14-.88.58-1l1.82-.45c.29-.07.51-.29.58-.58l.46-1.82c.1-.44.56-.7.99-.58l1.8.52c.3.09.6 0 .8-.2z"
        fill="#FEF4F2"
      />
      <path d="M12 7.22v5.18z" fill="#475569" />
      <path
        d="M12 7.22v5.18"
        stroke="#EF6144"
        strokeWidth={1.71}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.78c-.22 0-.4-.18-.4-.4s.18-.4.4-.4"
        stroke="#EF6144"
        strokeWidth={1.71}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.78c.22 0 .4-.18.4-.4s-.18-.4-.4-.4"
        stroke="#EF6144"
        strokeWidth={1.71}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.43 2.05c.31-.33.83-.33 1.14 0l1.3 1.35c.21.21.52.3.8.21l1.81-.52c.43-.12.88.14 1 .58l.45 1.82c.07.29.3.51.58.58l1.82.46c.44.1.7.56.58.99l-.52 1.8c-.09.3 0 .6.2.8l1.36 1.3c.33.32.33.84 0 1.15l-1.35 1.3c-.21.21-.3.52-.21.8l.52 1.81c.12.43-.14.88-.58 1l-1.82.45c-.29.07-.51.3-.58.58l-.46 1.82c-.1.44-.56.7-.99.58l-1.8-.52c-.3-.09-.6 0-.8.2l-1.3 1.36c-.32.33-.84.33-1.15 0l-1.3-1.35c-.21-.21-.52-.3-.8-.21l-1.81.52c-.43.12-.88-.14-1-.58l-.45-1.82c-.07-.29-.29-.51-.58-.58l-1.82-.46c-.44-.1-.7-.56-.58-.99l.52-1.8c.09-.3 0-.6-.2-.8l-1.36-1.3c-.33-.32-.33-.84 0-1.15l1.35-1.3c.21-.21.3-.52.21-.8L3.1 7.52c-.12-.43.14-.88.58-1l1.82-.45c.29-.07.51-.29.58-.58l.46-1.82c.1-.44.56-.7.99-.58l1.8.52c.3.09.6 0 .8-.2z"
        stroke="#EF6144"
        strokeWidth={1.71}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6809_5994">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconWorst;
